import { FC } from "react";
import { Grid } from "@chakra-ui/layout";
import { LinkIcon } from "lib/icons/link";
import { isPreviewingPack, md } from "lib/utils";
import { AssetTitle } from "domains/single-asset";
import { useLoggedinUser, usePack } from "lib/hooks";
import { useRouter } from "next/router";
import { usePackContext } from "domains/pack";
import { isEditable } from "domains/single-asset/utils";
import { openLink } from "./utils";

export const DefaultLinkAsset:FC<any> = ({ asset, title, url }) => {
  const { data: user } = useLoggedinUser();
  const { pathname } = useRouter();
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);
  
  const canEdit = isEditable(asset, user, pack) && !isPreviewingPack(pathname);
  
  return (
    <Grid templateColumns={["20px auto", "30px auto"]} gap="12px" alignItems="center" onClick={!canEdit ? (e) => openLink(e, asset) : null}>
      <LinkIcon fill="brand.500" iconHash={asset.data.icon_hash} assetId={asset.id} />
      <AssetTitle title={title ? md.render(title) : `<p>${url}</p>`} />
    </Grid>
  );
};
